<template>
  <full-container>
    <!--工具条-->
    <div slot="header">
      <el-form :inline="true" :model="queryParams" size="small" class="search-form">
        <el-form-item>
          <el-input v-model="queryParams.keyWord" placeholder="名称关键字" clearable />
        </el-form-item>
        <el-button type="primary" size="small" @click="onSearch()">查询</el-button>
      </el-form>
    </div>

    <!--表格-->
    <el-table v-loading="loading" ref="tb" :data="datalist.Items" height="100%">
      <el-table-column prop="Id" label="ID" width="80" />
      <el-table-column prop="UserName" label="姓名" min-width="100" />
      <el-table-column prop="Account" label="登录名" min-width="100" />
      <el-table-column prop="Ip" label="登录IP" min-width="100" />
      <el-table-column prop="LoginTime" label="登录时间" min-width="100" />
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-pagination :page-size="queryParams.size" :total="datalist.TotalCount" @current-change="onSearch" />
    </div>
  </full-container>
</template>



<script>
export default {
  data () {
    return {
      loading: false,
      datalist: [],
      queryParams: {
        index: 1,
        size: 20,
      },
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 查询参数
    onSearch (val = 1) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.system.user.getLogs(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
